import Routing from './routing/Routing'
import { Provider } from 'react-redux'
import store from './store/store'
import i18n from './locales/i18n';
import { I18nextProvider } from 'react-i18next';

const App = () => {
  return (
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <Routing />
      </Provider>
    </I18nextProvider>
  )
}

export default App